import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';
import { Palette } from '@material-ui/icons';

interface IStandardInputComponentProps {
  id: string;
  label: string;
  value: string | null | undefined;
  onChange: (event: any) => void;
  autoCompleteOff?: boolean | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    input: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.primary.main,
      borderRadius: '10px',
    },
    label: {
      color: theme.palette.primary.main,
      borderRadius: '10px',
    },
  }),
);

export default function StandardInputComponent(
  props: IStandardInputComponentProps,
) {
  const { id, label, value, onChange, autoCompleteOff } = props;
  const classes = useStyles(baseTheme);

  return (
    <>
      <InputLabel htmlFor={`filled-${id}`} className={classes.label}>{label}</InputLabel>
      <FilledInput
        id={`filled-${id}`}
        type="text"
        value={value}
        onChange={onChange}
        className={classes.input}
        autoComplete={autoCompleteOff ? 'off' : 'on'}
      />
    </>
  );
}
